'use client';

import { useResumeBuilderStore } from '@/stores/resume-builder-store';
import { Input } from '@/components/ui/forms/input';
import { Label } from '@/components/ui/forms/label';
import { ProfilePictureField } from '@/components/features/resume/ProfilePictureField';
import { templateSupportsProfilePhoto } from '@/lib/resume/templates/registry';

export default function PersonalInfoSection() {
  const { resume, updateContent } = useResumeBuilderStore();

  if (!resume) return null;

  const { personalInfo } = resume.content;

  const handleChange = (field: 'firstName' | 'lastName' | 'profilePictureUrl', value: string) => {
    updateContent({
      personalInfo: {
        ...personalInfo,
        [field]: value,
      },
    });
  };

  return (
    <div className="space-y-4">
      <div className="grid gap-4 sm:grid-cols-2">
        <div className="space-y-2">
          <Label htmlFor="firstName">First Name *</Label>
          <Input
            id="firstName"
            value={personalInfo.firstName}
            onChange={(e) => handleChange('firstName', e.target.value)}
            placeholder="John"
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="lastName">Last Name *</Label>
          <Input
            id="lastName"
            value={personalInfo.lastName}
            onChange={(e) => handleChange('lastName', e.target.value)}
            placeholder="Doe"
          />
        </div>
      </div>
      <ProfilePictureField
        value={personalInfo.profilePictureUrl}
        onChange={(url) => handleChange('profilePictureUrl', url)}
        templateShowsPhoto={templateSupportsProfilePhoto(resume.settings.templateId)}
      />
    </div>
  );
}
